import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useComponentModalInstance } from '@/share/components';

import { ref, toRaw, unref, reactive, onBeforeMount } from 'vue';
import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'proj-kpi-audit-flow-picker',
  setup(__props) {
    const gridRef = ref();
    const list = ref([]);
    const selectRow = ref();
    const $modal = useComponentModalInstance();
    const {
      loading,
      runAsync: myOrgGetCfgListApi
    } = fetchApi('kpi.auditFlowCfg.myOrgGetCfgList');
    const doModalResult = () => {
      if ($modal && $modal.isModal()) {
        $modal.confirm(toRaw(unref(selectRow.value || {})));
      }
    };
    const handleSelectRow = row => {
      selectRow.value = row;
      doModalResult();
    };
    const loadData = async () => {
      const {
        error,
        rows
      } = await myOrgGetCfgListApi({});
      if (error) return Promise.resolve(false);
      list.value = rows;
    };
    const gridOptions = reactive({
      border: true,
      headerAlign: 'center',
      align: 'left',
      radioConfig: {
        trigger: 'row'
      },
      rowConfig: {
        isCurrent: true,
        isHover: true
      },
      columns: [{
        type: 'seq',
        title: '序号',
        width: 70,
        fixed: 'left '
      }, {
        field: 'name',
        title: '流程名称',
        width: 220
      }, {
        field: 'action',
        title: '选择',
        width: 100,
        slots: {
          default: 'action'
        }
      }]
    });
    const gridEventHandlers = {
      'currentRowChange'({
        row
      }) {
        selectRow.value = row;
      },
      'cellDblClick'({
        row
      }) {
        selectRow.value = row;
        doModalResult();
      }
    };
    onBeforeMount(() => {
      loadData();
    });
    return (_ctx, _cache) => {
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_vxe_grid = _resolveComponent("vxe-grid");
      return _openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
        ref_key: "gridRef",
        ref: gridRef,
        loading: _unref(loading),
        data: _unref(list)
      }, _unref(gridOptions), _toHandlers(gridEventHandlers)), {
        action: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_button, {
          status: "primary",
          mode: "text",
          onClick: () => handleSelectRow(row)
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("选择", -1)]))]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      }, 16, ["loading", "data"]);
    };
  }
};